export const INTAKE_PINNED_CLASS_LABELS = ['EVAL-LCDC', 'EVAL'];

function normalizedClassLabel(item = {}) {
  return String(item.name || item.code || '').trim().toUpperCase();
}

export function isPinnedIntakeCalendarClass(item) {
  return INTAKE_PINNED_CLASS_LABELS.includes(normalizedClassLabel(item));
}

export function mergeIntakeCalendarLegendClasses(visibleClasses, availableClasses) {
  const classesById = new Map();

  [...visibleClasses, ...availableClasses
    .filter((item) => item?.active !== false && item?.is_active !== false)
    .filter(isPinnedIntakeCalendarClass)].forEach((item) => {
    if (!item?.id) return;
    classesById.set(String(item.id), item);
  });

  return [...classesById.values()].sort((a, b) => {
    const aPinnedIndex = INTAKE_PINNED_CLASS_LABELS.indexOf(normalizedClassLabel(a));
    const bPinnedIndex = INTAKE_PINNED_CLASS_LABELS.indexOf(normalizedClassLabel(b));
    const aRank = aPinnedIndex === -1 ? Number.MAX_SAFE_INTEGER : aPinnedIndex;
    const bRank = bPinnedIndex === -1 ? Number.MAX_SAFE_INTEGER : bPinnedIndex;
    return aRank - bRank;
  });
}
